import { DEFAULT_CURRENCY_CODE, Provider } from '@angular/core';

export const provideDefaultCurrencyCode = (): Provider => {
  return {
    provide: DEFAULT_CURRENCY_CODE,
    useValue: 'EUR'
  };
};
